<template>
  <div>
    <Breadcrumbs
      :children="[
        {
          text: `Tabla`,
        },
      ]"
    />

    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <div v-else class="card ml-3">
      <div class="card-body">
        <div class="col-sm-6 mb-2">
          <input
            type="text"
            @input="filterByIdNumberCell"
            v-model="filter"
            class="form-control"
            placeholder="Filtrar por pantalla, metodos, Correo"
          />
        </div>

        <div style="overflow-y: auto; max-height: 70vh; overflow-x: auto">
          <table class="table" id="list-supliers">
            <thead class="thead-light">
              <tr>
                <th>Correo de usuario</th>
                <th>Pantalla</th>
                <th>Fecha de creacion</th>
                <th>Parametros</th>
                <th>Metodo</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              <tr v-show="loading && analyticsLocal.length === 0">
                <td class="text-center" colspan="8">
                  <Loader />
                </td>
              </tr>
              <tr v-for="service in analyticsLocal" :key="service.Id">
                <td>{{ service.UserEmail || "N/A" }}</td>
                <td>{{ service.Screen }}</td>
                <td>{{ service.createdAt | formaDate }}</td>
                <td>{{ service.Parameters }}</td>
                <td>{{ service.MethodAction }}</td>
                <td>{{ service.Error }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader";
import { AnalyticService } from "../../services/AnalyticService";
import Breadcrumbs from "../components/Breadcrumbs";
import moment from "moment";
export default {
  name: "Analytics",
  components: {
    Loader,
    Breadcrumbs,
  },
  filters: {
    formaDate(value) {
      debugger;
      if (value) {
        return moment(value).format("DD/MM/YYYY");
      }
    },
    formaDateCreate(value) {
      if (value) {
        return moment.utc(value).format("hh:mm:ss A");
      }
    },
  },
  data: function () {
    return {
      analytics: [],
      analyticsLocal: [],
      loading: false,
      filter: "",
      paginationData: {
        currentPage: 1,
        totalOrders: 0,
        itemsPerPage: 7,
      },
      analyticService: new AnalyticService(),
    };
  },
  methods: {
    async getServices() {
      try {
        this.loading = true;

        const res = await this.analyticService.getAllAnalytics();

        this.analytics = res.data;
        this.analyticsLocal = this.analytics;

        this.loading = false;
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");

        this.loading = false;
      }
    },
    filterByIdNumberCell(event) {
      if (this.filter != "") {
        this.analyticsLocal = this.analytics.filter(
          (g) =>
            g.Screen.toString()
              .toLowerCase()
              .includes(this.filter.toLowerCase()) ||
            g.MethodAction.toString()
              .toLowerCase()
              .includes(this.filter.toLowerCase()) ||
            g.UserEmail.toString()
              .toLowerCase()
              .includes(this.filter.toLowerCase())
        );
      } else {
        this.analyticsLocal = this.analytics;
      }
    },
  },
  mounted: async function () {
    await this.getServices();
  },
};
</script>
